import React, { useEffect, useState } from 'react';
import { AgencyService } from '../AgencyService';
import { useNavigate } from 'react-router';
import { IUser } from '../../../model/user/IUser';
import { Card, Dropdown, DropdownButton, Table } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import InfluencerRemoveModal from './InfluencerRemoveModal';
import { formatDate } from '../../../utils/Functions';
import { CustomImageHandler } from '../../../shared/components/img/CustomImageHandler';
import { ErrorToast } from '../../../utils/toasters';
import Flag from '../../../shared/components/Flag';
import EmptyState from '../../../shared/components/EmptyState';

export function InfluencersAgency() {
    const navigate = useNavigate();
    const [users, setUsers] = useState<IUser[]>([]);
    const { id }: any = useParams();
    const [modalDeleteData, setModalDeleteData] = useState({
        showModal: false,
        userId: 0,
        userName: '',
    });
    const [change, setChange] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        AgencyService.getInfluencers(id)
            .then(data => {
                setUsers(data);
            })
            .catch(err => ErrorToast(err))
            .finally(() => setIsLoading(false));
    }, [change]);

    function disableUsers(id: number) {
        AgencyService.disableUser(id)
            .then(data => {
                setUsers(prevUsers => {
                    const updatedUsers = prevUsers.map(user =>
                        user.id === id ? { ...user, isEnabled: data.isEnabled } : user
                    );
                    return updatedUsers;
                });
            })
            .catch(err => ErrorToast(err));
    }

    function passData(route: string, data?: any) {
        navigate(route, {
            state: data,
        });
    }

    return (
        <>
            <InfluencerRemoveModal {...modalDeleteData} setModalDeleteData={setModalDeleteData} setChange={setChange} />

            {!isLoading && !users.length ? (
                <EmptyState classHolder="mb-5" />
            ) : (
                <Card className="mb-5 p-4">
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Photo</th>
                                <th>Displayname</th>
                                <th>Country</th>
                                <th>Enabled</th>
                                <th>Email</th>
                                <th>Last login</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(e => (
                                <tr key={e.id}>
                                    <td>{e.id}</td>
                                    <td>
                                        <CustomImageHandler
                                            altTag="user"
                                            classes="rounded-circle img-cover"
                                            thumbnailPath={e.profilePhoto?.thumbnail ?? ''}
                                            photoPath={e.profilePhoto?.thumbnail ?? ''}
                                            style={{ width: 50, height: 50 }}
                                        />
                                    </td>
                                    <td>
                                        {e.displayName}
                                        <br />
                                        {e.firstName} - {e.lastName}
                                    </td>
                                    <td>
                                        <Flag code={e?.contact?.country} />
                                    </td>
                                    <td>
                                        {e.isEnabled ? (
                                            <span className="word-break text-primary">
                                                <FaCheck />
                                            </span>
                                        ) : (
                                            <span className="word-break text-danger">
                                                <FaTimes />
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        <ImpersonateEye id={e.id ?? 0} />
                                        {e.email}
                                    </td>
                                    <td>
                                        {formatDate(e.lastLogin)}
                                        <br /> IP:{e.lastLoginIp}
                                    </td>
                                    <td>
                                        <DropdownButton align="end" title="Actions" id="dropdown-menu-align-right">
                                            <Dropdown.Item
                                                eventKey="1"
                                                onClick={() => passData(`/user/edit/${e.id}/true`)}
                                            >
                                                Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => disableUsers(e.id ?? 0)} eventKey="2">
                                                {e.isEnabled ? 'Disable' : 'Enable'}
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                eventKey="3"
                                                onClick={() => passData('/user/platforms', { id: e.id, user: e })}
                                            >
                                                Edit platforms
                                            </Dropdown.Item>

                                            <Dropdown.Divider></Dropdown.Divider>

                                            <Dropdown.Item
                                                className="bg-danger-o-50"
                                                onClick={() =>
                                                    setModalDeleteData({
                                                        ...modalDeleteData,
                                                        showModal: true,
                                                        userId: Number(e.id),
                                                        userName: e.displayName,
                                                    })
                                                }
                                            >
                                                Remove
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {users.length < 15 && !!users.length && <tbody className="h-180px"></tbody>}
                    </Table>
                </Card>
            )}
        </>
    );
}
